<template>
  <div class="min-wrapper xflex "
       style="padding: 10px;">
    <div class="chart-min xflex-1">
      <div id="m-line"
           class="m-line"
           ref="myChart">
      </div>
    </div>
  </div>
</template>

<script>
import hq from './wdhq.vue';
import echarts from 'echarts'
import moment from 'moment';
/* eslint-disable indent */
import {
  formatNumUnit
} from './js/numberFormat'
var bgColor = '#ffffff'; // 背景
var upColor = '#CC0000'; // 涨颜色
var downColor = '#20B120'; // 跌颜色
// ma  颜色
// var ma5Color = '#39afe6';
// var ma10Color = '#da6ee8';
// var ma20Color = '#ffab42';
// var ma30Color = '#00940b';
/**
   * 计算价格涨跌幅百分比
   * @param {Object} price 现价
   * @param {Object} yclose 昨收价
   */
function ratioCalculate (price, yclose) {
  return ((price - yclose) / yclose * 100).toFixed(2);
}

export default {
  components: {
    hq
  },
  props: ['mdata', 'code', 'shortname', 'maket'],
  data () {
    return {
      preclose: 0,
      mdata1: [],
      leftMax: 0,
      leftMin: 0,
      rightMax: 0,
      rightMin: 0,
      mChart: null,
      timeArr: [], // 根据品种取横轴坐标
      yestclose: 0
    }
  },
  computed: {
    digit () {
      return 2
    },
    divol () {
      return 1
    }
  },
  watch: {
    mdata: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.mdata1 = JSON.parse(JSON.stringify(newVal))
          this.drawLine()
        }
      },
      deep: true
    }
  },
  methods: {
    toDecimal (v) {
      if (!v) {
        return '--'
      }
      return parseFloat(v).toFixed(2)
    },
    formatNumUnit (value, fixedLen = 2, num = 100000) {
      return formatNumUnit(value, fixedLen, num)
    },
    /**
       * 15:20 时:分 格式时间增加num分钟
       * @param {Object} time 起始时间
       * @param {Object} num
       */
    addTimeStr (time, num) {
      let hour = time.split(':')[0];
      let mins = Number(time.split(':')[1]);
      let minsUn = parseInt((mins + num) / 60);
      let hourUn = parseInt((Number(hour) + minsUn) / 24);
      if (minsUn > 0) {
        if (hourUn > 0) {
          let tmpVal = ((Number(hour) + minsUn) % 24) + '';
          hour = tmpVal.length > 1 ? tmpVal : '0' + tmpVal; // 判断是否是一位
        } else {
          let tmpVal = Number(hour) + minsUn + '';
          hour = tmpVal.length > 1 ? tmpVal : '0' + tmpVal;
        }
        let tmpMinsVal = ((mins + num) % 60) + '';
        mins = tmpMinsVal.length > 1 ? tmpMinsVal : 0 + tmpMinsVal; // 分钟数为 取余60的数
      } else {
        let tmpMinsVal = mins + num + '';
        mins = tmpMinsVal.length > 1 ? tmpMinsVal : '0' + tmpMinsVal; // 不大于整除60
      }
      return hour + ':' + mins;
    },

    /**
       * 不同类型的股票的交易时间会不同
       * @param {Object} type   hs=沪深  us=美股  hk=港股
       */
    time_arr (type, time) {
      return this.timeArr
    },
    // 重组分时数据
    get_m_data (mData, type) {
      let priceArr = [];
      let avgPrice = [];
      let vol = [];
      let times = [];
      let changeRatio = [];
      if (mData && mData.length > 0) {
        mData.forEach((v) => {
          priceArr.push(Number(v['ClosePrice']));
          avgPrice.push(Number(v['OpenPrice']));
          vol.push(Number(v['TotalVolumeTraded']));
          changeRatio.push(Number(v['ChangeRatio']))
          if (v[7] !== '00:00') {
            times.push(moment(new Date(v['UTCDateTime'])).format('hh:mm'))
          }
        })
      }
      let obj = {
        priceArr: priceArr,
        avgPrice: avgPrice,
        vol: vol,
        times: times,
        changeRatio: changeRatio,
        yestclose: Number(mData[mData.length - 1].ClosePrice)
      }
      this.yestclose = obj.yestclose
      this.getMaxMin(obj)
      return obj
    },
    getMaxMin (obj) {
      let avgMax;
      let avgMin;
      let priceMax;
      let priceMin = 0;
      avgMax = this.getMax(obj.avgPrice);
      avgMin = this.getMin(obj.avgPrice);
      priceMax = this.getMax(obj.priceArr);
      priceMin = this.getMin(obj.priceArr);

      const middleLineVal = obj.yestclose;
      if ((middleLineVal - priceMax) * -1 > (middleLineVal - priceMin)) {
        priceMin = (middleLineVal - ((middleLineVal - priceMax) * -1));
      } else {
        priceMax = (middleLineVal + (middleLineVal - priceMin));
      }
      this.leftMax = avgMax > priceMax ? avgMax : priceMax
      this.leftMin = avgMin > priceMin ? priceMin : avgMin
      this.leftInterval = (this.leftMax - this.leftMin) / 2

      this.rightMax = this.getMax(obj.changeRatio)
      this.rightMin = this.getMin(obj.changeRatio)

      const middleLineVal1 = 0;
      const max1 = this.rightMax - middleLineVal1
      const min1 = middleLineVal1 - this.rightMin
      const absMax1 = Math.max(Math.abs(max1), Math.abs(min1));

      if (absMax1 === 0) {
        this.rightMax = middleLineVal1 * 1.05
        this.rightMin = middleLineVal1 * 0.95
      } else {
        this.rightMax = middleLineVal1 + absMax1
        this.rightMin = middleLineVal1 - absMax1
      }
      this.rightInterval = Number(
        this.toDecimal(
          (this.rightMax - this.rightMin) / 2,
          3,
          true
        )
      );
    },
    getMax (arr) {
      const maxList = arr.filter((item) => item !== '-' && item !== 0);
      let Max = 0;
      if (maxList.length > 0) {
        const max0 = maxList[0];
        Max = max0;
        maxList.forEach((item) => {
          if (Number(item) > Number(Max)) {
            Max = Number(item);
          }
        });
      }
      return Number(Max);
    },
    getMin (arr) {
      const minList = arr.filter((item) => item !== '-' && item !== 0);
      let Min = 0;
      if (minList.length > 0) {
        const min0 = minList[0];
        Min = min0;
        minList.forEach((item) => {
          if (Number(item) < Number(Min)) {
            Min = Number(item);
          }
        });
      }
      return Number(Min);
    },
    initData () {
      this.mdata1 = JSON.parse(JSON.stringify(this.mdata))
    },
    getTimeArr () {
      let timeArr = []
      return timeArr
    },
    /**
       * 生成分时option
       * @param {Object} mData 分时数据
       * @param {Object} type 股票类型  us-美股  hs-沪深  hk-港股
       */
    initMOption (mData, type) {
      let mDatas = this.get_m_data(mData, type);
      let _this = this;
      return {
        tooltip: { // 弹框指示器
          position: ['0%', '10%'],
          hideDelay: 10000,
          // position: function (pos, params, el, elRect, size) {
          //   let obj = { top: 10 };
          //   obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
          //   return obj;
          // },
          formatter: function (params, ticket, callback) {
            // console.log('params===', params, ticket, mDatas)
            let i = params[0].dataIndex;
            let cpriceColor;
            let avgPriceColor;
            let radioColor;
            if (params[0].seriesType !== 'line' || params[0].axisDim === 'y') {
              return ''
            }
            // 现价
            if (mDatas.priceArr[i] > _this.yestclose) {
              cpriceColor = 'style="color:#ff4242"';
            } else if (mDatas.priceArr[i] === _this.yestclose) {
              cpriceColor = 'style="color:#fff"';
            } else {
              cpriceColor = 'style="color:#26bf66"';
            }
            // 均价
            if (mDatas.avgPrice[i] > _this.yestclose) {
              avgPriceColor = 'style="color:#ff4242"';
            } else if (mDatas.avgPrice[i] === _this.yestclose) {
              avgPriceColor = 'style="color:#fff"';
            } else {
              avgPriceColor = 'style="color:#26bf66"';
            }
            // 涨幅
            if (mDatas.changeRatio[i] > 0) {
              radioColor = 'style="color:#ff4242"';
            } else if (mDatas.changeRatio[i] === 0) {
              radioColor = 'style="color:#fff"';
            } else {
              radioColor = 'style="color:#26bf66"';
            }
            let html = '<div>时间<span> ' + params[0].axisValue + '</span></div><br/>' +
              '<div class="commColor" style="width:100px;"><div>现价 <span  ' + cpriceColor + ' >' +
              _this.toDecimal(mDatas.priceArr[i], _this.digit) + '</span></div><br/>';
            html += '<div>均价 <span  ' + avgPriceColor + ' >' + _this.toDecimal(mDatas.avgPrice[i], _this.digit) + '</span></div><br/>';
            html += '<div>涨幅 <span  ' + radioColor + ' >' + mDatas.changeRatio[i] + '%</span></div><br/>';
            html += '<div>现手 <span style="color:#fff" >' + _this.formatNumUnit(mDatas.vol[i]) +
              '</span></div></div>'
            return params.length >= 6 ? html : '';
            // return html;
          }
        },
        color: ['#2f569e', '#F39142'],
        legend: { // 图例控件,点击图例控制哪些系列不显示
          icon: 'rect',
          type: 'scroll',
          itemWidth: 14,
          itemHeight: 2,
          left: 0,
          top: '-1%',
          data: ['现价', '均价', '现手'],
          textStyle: {
            fontSize: 12,
            color: '#999999'
          }
        },
        axisPointer: {
          show: true,
          link: {
            xAxisIndex: [0, 2]
          }
        },
        grid: [{
          id: 'gd1',
          left: '2%',
          right: '4%',
          height: '67.5%', // 主K线的高度,
          top: '5%'
        },
        {
          id: 'gd2',
          left: '2%',
          right: '4%',
          height: '67.5%', // 主K线的高度,
          top: '5%'
        }, {
          id: 'gd3',
          left: '2%',
          right: '4%',
          top: '75%',
          height: '19%' // 交易量图的高度
        }
        ],
        xAxis: [ // ==== x轴
          { // 主图
            gridIndex: 0,
            data: mDatas.times,
            show: false,
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'red',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            axisPointer: {
              label: {
                show: false
              }
            }
          },
          {
            show: false,
            gridIndex: 1,
            data: mDatas.times,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisPointer: {
              label: {
                show: false
              }
            }
          }, { // 交易量图
            // splitNumber: 2,
            type: 'category',
            gridIndex: 2,
            data: mDatas.times,
            axisLabel: { // label文字设置
              color: '#9b9da9',
              fontSize: 8,
              interval: 59,
              textAlign: 'center'
            }
          }
        ],
        yAxis: [ // y轴
          {
            gridIndex: 0,
            scale: true,
            splitNumber: 3,
            axisLabel: { // label文字设置
              inside: true, // label文字朝内对齐
              // fontWeight:'bold',
              fontSize: 10,
              color: function (val) {
                if (val === _this.yestclose) {
                  return '#aaa'
                }
                return val > _this.yestclose ? upColor : downColor;
              },
              formatter: function (val) {
                return _this.toDecimal(val, _this.digit)
              }
            },
            z: 4,
            splitLine: { // 分割线设置
              show: false,
              lineStyle: {
                color: '#181a23'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'transparent',
                width: 0 // 这里是为了突出显示加上的
              }
            },
            axisPointer: {
              show: true,
              label: {
                show: false
              }
            },
            min: _this.leftMin,
            max: _this.leftMax,
            interval: _this.leftInterval

          }, {
            scale: true,
            gridIndex: 1,
            splitNumber: 3,
            position: 'right',
            z: 4,
            axisLabel: { // label文字设置
              interval: true,

              color: function (val) {
                if (val === 0) {
                  return '#aaa'
                }
                return val > 0 ? upColor : downColor;
              },
              inside: true, // label文字朝内对齐
              // fontWeight:'bold',
              fontSize: 10,
              formatter: function (val) {
                return _this.toDecimal(val, 2, true) + '%'
              }
            },
            splitLine: { // 分割线设置
              show: false,
              lineStyle: {
                color: '#181a23'
              }
            },
            axisPointer: {
              show: true,
              label: {
                show: false
              }
            },
            axisLine: {
              lineStyle: {
                color: 'transparent',
                width: 0 // 这里是为了突出显示加上的
              }
            },
            min: _this.rightMin,
            max: _this.rightMax,
            interval: _this.rightInterval
          }, { // 交易图
            gridIndex: 2,
            z: 4,
            splitNumber: 3,
            axisLine: {
              onZero: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: { // label文字设置
              color: '#c7c7c7',
              inside: true, // label文字朝内对齐
              fontSize: 8,
              formatter: function (value) {
                return _this.formatNumUnit(value);
              }
            }
          }
        ],
        dataZoom: [

        ],
        animation: false, // 禁止动画效果
        backgroundColor: bgColor,
        blendMode: 'source-over',
        series: [{
          name: '现价',
          type: 'line',
          data: mDatas.priceArr,
          smooth: true,
          symbol: 'none', // 中时有小圆点
          lineStyle: {
            normal: {
              opacity: 0.8,
              color: '#2f569e',
              width: 1
            }
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(246, 246, 255, 1)'
              }, {
                offset: 0.8,
                color: 'rgba(246, 246, 255, 0.5)'
              }], false),
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
            }
          },
          markLine: {
            silent: true,
            symbol: ['none', 'none'],
            label: {
              normal: {
                show: false,
                color: '#fff'
              }
            },
            lineStyle: {
              color: '#2f569e',
              opacity: 0.5,
              type: 'dot'
            },
            data: [{
              name: 'Y 轴值为 yAxis 的水平线',
              yAxis: _this.toDecimal(_this.yestclose, _this.digit)
            }]
          }

        },

        {
          name: '均价',
          type: 'line',
          data: mDatas.avgPrice,
          smooth: true,
          symbol: 'none',
          lineStyle: { // 标线的样式
            normal: {
              opacity: 0.8,
              color: '#F39142',
              width: 1
            }
          }
        },
        {
          type: 'line',
          data: mDatas.priceArr,
          smooth: true,
          symbol: 'none',
          gridIndex: 1,
          xAxisIndex: 1,
          yAxisIndex: 1,
          lineStyle: { // 标线的样式
            normal: {
              width: 0
            }
          }
        },
        {
          name: '现手',
          type: 'bar',
          gridIndex: 2,
          xAxisIndex: 2,
          yAxisIndex: 2,
          data: mDatas.vol,
          barWidth: '60%',
          itemStyle: {
            normal: {
              color: function (params) {
                let colorList = ''
                if (params.dataIndex === 0) {
                  if (mDatas.priceArr[0] >= _this.yestclose) {
                    colorList = upColor
                  } else {
                    colorList = downColor
                  }
                } else {
                  if (mDatas.priceArr[params.dataIndex] >= mDatas.priceArr[params.dataIndex - 1]) {
                    colorList = upColor;
                  } else {
                    colorList = downColor;
                  }
                }

                return colorList
              }
            }
          }
        }
        ]
      };
    },
    aboutMaxAbs (arr, closeVal, digit) {
      let absArr = []
      arr.forEach(el => {
        absArr.push(Math.abs(el - closeVal))
      })
      let max = Math.max(...absArr)
      let maxVal = max + closeVal;
      let minVal = closeVal - max;
      return [maxVal.toFixed(digit), minVal.toFixed(digit)];
    },
    initMOption2 (mData, type) {
      let mDatas = this.get_m_data(mData, type);
      let _this = this;
      let leftArr = this.aboutMaxAbs(mDatas.priceArr, _this.yestclose, this.digit);
      console.log('leftArr----', leftArr[0], leftArr[1])
      let multiple = Math.pow(10, _this.digit);
      let handleYest = _this.toDecimal(_this.yestclose, _this.digit) * multiple;
      let handleMin = leftArr[1] * multiple;
      let intervalL = Math.round((handleYest - handleMin)) / multiple;
      if (leftArr[0] === leftArr[1]) {
        if (leftArr[0] === 'NaN' && !_this.yestclose) {
          leftArr[0] = 101
          leftArr[1] = 99
          _this.yestclose = 100
        } else {
          leftArr[0] = leftArr[0] * 1 + 1
          leftArr[1] = leftArr[1] * 1 - 1
        }
      }
      return {
        tooltip: { // 弹框指示器
          position: ['0%', '10%'],
          animation: false,
          hideDelay: 10000,
          formatter: function (params, ticket, callback) {
            // console.log("2params",params)
            let i = params[0].dataIndex;
            let cpriceColor;
            let avgPriceColor;
            let radioColor;
            if (params[0].seriesType !== 'line' || params[0].axisDim === 'y') {
              return ''
            }
            // 现价
            if (mDatas.priceArr[i] > _this.yestclose) {
              cpriceColor = 'style="color:#ff4242"';
            } else if (mDatas.priceArr[i] === _this.yestclose) {
              cpriceColor = 'style="color:#fff"';
            } else {
              cpriceColor = 'style="color:#26bf66"';
            }
            // 均价
            if (mDatas.avgPrice[i] > _this.yestclose) {
              avgPriceColor = 'style="color:#ff4242"';
            } else if (mDatas.avgPrice[i] === _this.yestclose) {
              avgPriceColor = 'style="color:#fff"';
            } else {
              avgPriceColor = 'style="color:#26bf66"';
            }
            // 涨幅
            if (mDatas.changeRatio[i] > 0) {
              radioColor = 'style="color:#ff4242"';
            } else if (mDatas.changeRatio[i] === 0) {
              radioColor = 'style="color:#fff"';
            } else {
              radioColor = 'style="color:#26bf66"';
            }

            var html = '<div>时间 <span> ' + params[0].axisValue + '</span></div><br/>' +
              '<div class="commColor" style="width:100px;"><div>现价 <span  ' + cpriceColor + ' >' +
              _this.toDecimal(mDatas.priceArr[i], _this.digit) + '</span></div><br/>';
            if (mDatas.avgPrice[i]) {
              html += '<div>均价 <span  ' + avgPriceColor + ' >' + _this.toDecimal(mDatas.avgPrice[i], _this.digit) + '</span></div><br/>';
            }
            html += '<div>涨幅 <span  ' + radioColor + ' >' + mDatas.changeRatio[i] + '%</span></div><br/>';
            html += '<div>现手 <span style="color:#fff" >' + _this.formatNumUnit(mDatas.vol[i]) +
              '</span></div></div>'
            // return params.length >=6 ? html : '';
            return html;
          }
        },
        color: ['#2f569e', '#F39142', '#ff4242'],
        legend: { // 图例控件,点击图例控制哪些系列不显示
          icon: 'rect',
          type: 'plain',
          itemWidth: 14,
          itemHeight: 2,
          left: 0,
          top: '-1%',
          data: ['现价', '现手'],
          textStyle: {
            fontSize: 12,
            color: '#999999'
          }
        },
        axisPointer: {
          show: true,
          link: {
            xAxisIndex: [0, 2]
          }
        },
        grid: [{
          id: 'gd1',
          left: '2%',
          right: '4%',
          height: '67.5%', // 主K线的高度,
          top: '5%'
        },
        {
          id: 'gd2',
          left: '2%',
          right: '4%',
          height: '67.5%', // 主K线的高度,
          top: '5%'
        }, {
          id: 'gd3',
          left: '2%',
          right: '4%',
          top: '75%',
          height: '19%' // 交易量图的高度
        }
        ],
        xAxis: [ // ==== x轴
          { // 主图
            gridIndex: 0,
            data: mDatas.times,
            show: false,
            axisLabel: { // label文字设置
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'blue',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            axisPointer: {
              label: {
                show: false
              }
            }
          },
          {
            show: false,
            gridIndex: 1,
            data: mDatas.times,
            axisLabel: { // label文字设置
              show: false
            },
            splitLine: {
              show: false
            },
            axisPointer: {
              label: {
                show: false
              }
            }
          }, { // 交易量图
            splitNumber: 2,
            type: 'category',
            gridIndex: 2,
            data: mDatas.times,
            axisLabel: { // label文字设置
              color: '#9b9da9',
              fontSize: 8,
              interval: 59,
              textAlign: 'center'
            }
          }
        ],
        yAxis: [ // y轴
          {
            gridIndex: 0,
            scale: true,
            splitNumber: 3,
            axisLabel: { // label文字设置
              inside: true, // label文字朝内对齐
              // fontWeight:'bold',
              fontSize: 10,
              color: function (val) {
                if (val * 1 === _this.yestclose * 1) {
                  return '#aaa'
                }
                return val > _this.yestclose ? upColor : downColor;
              },
              formatter: function (val) {
                return _this.toDecimal(val, _this.digit)
              }
            },
            z: 4,
            splitLine: { // 分割线设置
              show: false,
              lineStyle: {
                color: '#181a23'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'transparent',
                width: 0 // 这里是为了突出显示加上的
              }
            },
            axisPointer: {
              show: true,
              label: {
                show: false
              }
            },
            min: leftArr[1],
            max: leftArr[0],
            interval: intervalL

          }, {
            scale: true,
            gridIndex: 1,
            splitNumber: 3,
            position: 'right',
            z: 4,
            axisLabel: { // label文字设置
              interval: true,

              color: function (val) {
                if (val === 0) {
                  return '#aaa'
                }
                return val > 0 ? upColor : downColor;
              },
              inside: true, // label文字朝内对齐
              // fontWeight:'bold',
              fontSize: 10,
              formatter: function (val) {
                return _this.toDecimal(val, 2, true) + '%'
              }
            },
            splitLine: { // 分割线设置
              show: false,
              lineStyle: {
                color: '#181a23'
              }
            },
            axisPointer: {
              show: true,
              label: {
                show: false
              }
            },
            axisLine: {
              lineStyle: {
                color: 'transparent',
                width: 0 // 这里是为了突出显示加上的
              }
            },
            min: _this.rightMin,
            max: _this.rightMax,
            interval: _this.rightInterval
          }, { // 交易图
            gridIndex: 2,
            z: 4,
            splitNumber: 3,
            axisLine: {
              onZero: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: { // label文字设置
              color: '#c7c7c7',
              inside: true, // label文字朝内对齐
              fontSize: 8,
              formatter: function (value) {
                return _this.formatNumUnit(value);
              }
            }
          }
        ],
        dataZoom: [

        ],
        animation: false, // 禁止动画效果
        backgroundColor: bgColor,
        blendMode: 'source-over',
        series: [{
          name: '现价',
          type: 'line',
          data: mDatas.priceArr,
          smooth: true,
          symbol: 'none', // 中时有小圆点
          lineStyle: {
            normal: {
              opacity: 0.8,
              color: '#2f569e',
              width: 1
            }
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(246, 246, 255, 1)'
              }, {
                offset: 0.8,
                color: 'rgba(246, 246, 255, 0.5)'
              }], false),
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
            }
          },
          markLine: {
            silent: true,
            symbol: ['none', 'none'],
            label: {
              normal: {
                show: false,
                color: '#fff'
              }
            },
            lineStyle: {
              color: '#2f569e',
              opacity: 0.5,
              type: 'dot'
            },
            data: [{
              name: 'Y 轴值为 yAxis 的水平线',
              yAxis: _this.toDecimal(_this.yestclose, _this.digit)
            }]
          }

        },

        {
          type: 'line',
          data: mDatas.priceArr,
          smooth: true,
          symbol: 'none',
          gridIndex: 1,
          xAxisIndex: 1,
          yAxisIndex: 1,
          lineStyle: { // 标线的样式
            normal: {
              width: 0
            }
          }
        },
        {
          name: '现手',
          type: 'bar',
          gridIndex: 2,
          xAxisIndex: 2,
          yAxisIndex: 2,
          data: mDatas.vol,
          barWidth: '60%',
          itemStyle: {
            normal: {
              color: function (params) {
                let colorList = ''
                if (params.dataIndex === 0) {
                  if (mDatas.priceArr[0] >= _this.yestclose) {
                    colorList = upColor
                  } else {
                    colorList = downColor
                  }
                } else {
                  if (mDatas.priceArr[params.dataIndex] >= mDatas.priceArr[params.dataIndex - 1]) {
                    colorList = upColor;
                  } else {
                    colorList = downColor;
                  }
                }

                return colorList
              }
            }
          }
        }
        ]
      };
    },

    initMOption1 (mData, type) {
      let mDatas = this.get_m_data(mData, type);
      return {
        tooltip: { // 弹框指示器
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          formatter: function (params, ticket, callback) {
            let i = params[0].dataIndex;
            let cpriceColor;
            let avgPriceColor;
            let radioColor;
            // 现价
            if (mDatas.priceArr[i] > _this.yestclose) {
              cpriceColor = 'style="color:#ff4242"';
            } else if (mDatas.priceArr[i] === _this.yestclose) {
              cpriceColor = 'style="color:#fff"';
            } else {
              cpriceColor = 'style="color:#26bf66"';
            }
            // 均价
            if (mDatas.avgPrice[i] > _this.yestclose) {
              avgPriceColor = 'style="color:#ff4242"';
            } else if (mDatas.avgPrice[i] === _this.yestclose) {
              avgPriceColor = 'style="color:#fff"';
            } else {
              avgPriceColor = 'style="color:#26bf66"';
            }
            // 涨幅
            if (mDatas.changeRatio[i] > 0) {
              radioColor = 'style="color:#ff4242"';
            } else if (mDatas.changeRatio[i] === 0) {
              radioColor = 'style="color:#fff"';
            } else {
              radioColor = 'style="color:#26bf66"';
            }

            let html = '<div>时间 <span> ' + params[0].axisValue + '</span></div><br/>' +
              '<div class="commColor" style="width:100px;"><div>现价 <span  ' + cpriceColor + ' >' +
              _this.toDecimal(mDatas.priceArr[i], _this.digit) + '</span></div><br/>';
            html += '<div>均价 <span  ' + avgPriceColor + ' >' + _this.toDecimal(mDatas.avgPrice[i], _this.digit) + '</span></div><br/>';
            html += '<div>涨幅 <span  ' + radioColor + ' >' + mDatas.changeRatio[i] + '%</span></div><br/>';
            html += '<div>现手 <span style="color:#fff" >' + _this.formatNumUnit(mDatas.vol[i]) +
              '</span></div></div>'
            return params.length >= 6 ? html : '';
          }
        },
        animation: false,
        legend: { // 图例控件,点击图例控制哪些系列不显示
          icon: 'rect',
          type: 'scroll',
          itemWidth: 14,
          itemHeight: 2,
          left: 0,
          top: '-1%',
          data: ['现价', '现手'],
          textStyle: {
            fontSize: 12,
            color: '#999999'
          }
        },
        axisPointer: {
          show: true
        },
        grid: [{
          id: 'gd1',
          left: '2%',
          right: '4%',
          height: '67.5%', // 主K线的高度,
          top: '5%'
        },
        {
          id: 'gd2',
          left: '2%',
          right: '4%',
          height: '67.5%', // 主K线的高度,
          top: '5%'
        }, {
          id: 'gd3',
          left: '2%',
          right: '4%',
          top: '75%',
          height: '19%' // 交易量图的高度
        }
        ],
        xAxis: [ // ==== x轴

          { // 主图
            gridIndex: 0,
            data: mDatas.times,
            show: false,
            axisLabel: { // label文字设置
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'blue',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          },
          {
            show: false,
            gridIndex: 1,
            data: mDatas.times,
            axisLabel: { // label文字设置
              show: false
            },
            splitLine: {
              show: false
            }
          }, { // 交易量图
            splitNumber: 2,
            type: 'category',
            gridIndex: 2,
            data: mDatas.times,
            axisLabel: { // label文字设置
              color: '#9b9da9',
              fontSize: 8,
              textAlign: 'right'
            }
          }
        ],
        yAxis: [ // y轴
          {
            gridIndex: 0,
            scale: true,
            splitNumber: 3,
            axisLabel: { // label文字设置
              inside: true, // label文字朝内对齐
              // fontWeight:'bold',
              fontSize: 10,
              color: function (val) {
                if (val === _this.yestclose) {
                  return '#aaa'
                }
                return val > _this.yestclose ? upColor : downColor;
              }
            },
            z: 4,
            splitLine: { // 分割线设置
              show: false,
              lineStyle: {
                color: '#181a23'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'transparent',
                width: 0 // 这里是为了突出显示加上的
              }
            },
            axisPointer: {
              show: true,
              label: {
                show: false
              }
            }

          }, {
            scale: true,
            gridIndex: 1,
            splitNumber: 3,
            position: 'right',
            z: 4,
            axisLabel: { // label文字设置
              color: function (val) {
                if (val === _this.yestclose) {
                  return '#aaa'
                }
                return val > _this.yestclose ? upColor : downColor;
              },
              inside: true, // label文字朝内对齐
              // fontWeight:'bold',
              fontSize: 10,
              formatter: function (val) {
                var resul = ratioCalculate(val, _this.yestclose);
                return Number(resul).toFixed(2) + ' %'
              }
            },
            splitLine: { // 分割线设置
              show: false,
              lineStyle: {
                color: '#181a23'
              }
            },
            axisPointer: {
              show: true,
              label: {
                show: false,
                formatter: function (params) { // 计算右边Y轴对应的现价的涨幅比例
                  return ratioCalculate(params.value, mData.yestclose) + '%';
                }
              }
            },
            axisLine: {
              lineStyle: {
                color: 'transparent',
                width: 0 // 这里是为了突出显示加上的
              }
            }
          }, { // 交易图
            gridIndex: 2,
            z: 4,
            splitNumber: 3,
            axisLine: {
              onZero: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: { // label文字设置
              color: '#c7c7c7',
              inside: true, // label文字朝内对齐
              fontSize: 8
            }
          }
        ],
        dataZoom: [

        ],
        // animation:false,//禁止动画效果
        backgroundColor: bgColor,
        blendMode: 'source-over',
        series: [{
          name: '现价',
          type: 'line',
          data: mDatas.priceArr,
          smooth: true,
          symbol: 'circle', // 中时有小圆点
          lineStyle: {
            normal: {
              opacity: 0.8,
              color: '#2f569e',
              width: 1
            }
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(246, 246, 255, 1)'
              }, {
                offset: 0.8,
                color: 'rgba(246, 246, 255, 0.5)'
              }], false),
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
            }
          },
          markLine: {
            silent: true,
            symbol: ['none', 'none'],
            label: {
              normal: {
                show: false,
                color: '#fff'
              }
            },
            lineStyle: {
              color: '#2f569e',
              opacity: 0.5,
              type: 'dot'
            },
            data: [{
              name: 'Y 轴值为 yAxis 的水平线',
              yAxis: _this.yestclose
            }]
          }
        },

        {
          type: 'line',
          data: mDatas.priceArr,
          smooth: true,
          symbol: 'none',
          gridIndex: 1,
          xAxisIndex: 1,
          yAxisIndex: 1,
          lineStyle: { // 标线的样式
            normal: {
              width: 0
            }
          }
        },
        {
          name: '现手',
          type: 'bar',
          gridIndex: 2,
          xAxisIndex: 2,
          yAxisIndex: 2,
          data: mDatas.vol,
          barWidth: '60%',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList;
                if (mDatas.priceArr[params.dataIndex] > mDatas.priceArr[params.dataIndex - 1]) {
                  colorList = upColor;
                } else {
                  colorList = downColor;
                }
                return colorList;
              }
            }
          }
        }
        ]
      };
    },
    drawLine () {
      let options = {}
      if (this.mdata1 && this.mdata1.length > 0) {
        if (this.mdata1.every(r => r[2] === 0)) {
          options = this.initMOption2(this.mdata1, 'hs')
        } else {
          options = this.initMOption(this.mdata1, 'hs')
        }
      }

      this.$nextTick(() => {
        this.myChart = echarts.init(this.$refs.myChart)
        this.myChart.setOption(options);
      })
    }

  },
  created () {
    this.timeArr = this.getTimeArr()
    this.initData()
  },
  mounted () {
    this.leftMax = 0;
    this.leftMin = 0;
    this.drawLine()
  },
  beforeDestroy () {
    console.log('触发图Min销毁')
    // let chartDom = document.getElementById('m-line')
    // echarts.dispose(this.mChart)
    // if (this.mChart != null && this.mChart !== '' && this.mChart !== undefined) {
    //   this.mChart.dispose();
    // }
  }

}
</script>

<style lang="less" scoped>
.xflex {
  -webkit-display: flex;
  -khtml-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  display: flex;
}

.xflex-1 {
  -webkit-flex: 1;
  -khtml-flex: 1;
  -moz-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.border1 {
  border: 1px solid red;
}

.xflex-a-c {
  -webkit-align-items: center;
  -khtml-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;
}

.xflex-j-s {
  -webkit-justify-content: space-between;
  -khtml-justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}

.xflex-j-c {
  -webkit-justify-content: center;
  -khtml-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}

.xflex-col {
  -webkit-flex-direction: column;
  -khtml-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.t-a-c {
  text-align: center;
}

.color-up {
  color: #cc0000;
}

.color-down {
  color: #20b120;
}

.min-wrapper {
  height: 100%;

  .hq-wrapper {
    width: 250rpx;
  }

  .chart-min {
    .m-line {
      // border: 1px solid blue;
      height: 400px;
      width: 500px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chart/chartMin.vue